<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="incentiveMonth"
              label="対象年月"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="monthForPicker"
            type="month"
            @input="menu = false"
            locale="jp-ja"
            no-title
            scrollable
            @change="onChangeMonth()"
          >
            <v-spacer></v-spacer>
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-card>
      <v-container fluid grid-list-xl>
        <v-card-title>勤務データアップロード</v-card-title>
        <v-layout row wrap>
          <v-flex xs6>
            <v-text-field
              label="勤務データ"
              @click="pickFile"
              v-model="fileName"
              prepend-icon="attach_file"
              hint="CSVファイル"
            ></v-text-field>
            <input
              accept="text/csv"
              type="file"
              ref="file"
              style="display: none"
              value="勤務データアップロード"
              @change="onFileChange($event)"
            />
          </v-flex>

          <v-flex xs3 align-self-center>
            <v-btn block color="info" dark :loading="loading" @click="upload()">
              <v-icon dark left>mdi-upload</v-icon>アップロード
            </v-btn>
            <v-btn block @click="clear()">
              <v-icon dark left>mdi-refresh</v-icon>クリア
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <div style="height: 30px;"></div>

    <v-card v-if="dispTable">
      <v-container>
        <v-card-title>売上報告と勤務データの差分</v-card-title>

        <v-data-table
          id="dt"
          :headers="diffSalesReportHeaders"
          :items="diffSalesReport"
          hide-actions
          class="elevation-1"
          style="width: 100%; margin: 15px 0 0;"
          :no-data-text="$t('noTableDataAvailable')"
        >
          <template v-slot:items="props">
            <tr v-if="props.item.dispFlg">
              <td
                class="text-xs-left px-2"
                @click="editSalesReport(props.item)"
              >{{ props.item.salesReportDate }}</td>
              <td
                class="text-xs-left px-2"
                @click="editSalesReport(props.item)"
              >{{ props.item.storeName }}</td>
              <td
                class="text-xs-left px-2"
                @click="editSalesReport(props.item)"
              >{{ props.item.reportUserId }}</td>
              <td
                class="text-xs-left px-2"
                @click="editSalesReport(props.item)"
              >{{ props.item.csvUserId }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <div style="height: 10px;"></div>
    <v-card v-if="dispTable">
      <v-container>
        <v-card-title>売上報告がない勤務データ</v-card-title>

        <v-data-table
          id="dt"
          :headers="noExistSalesReportHeaders"
          :items="noExistSalesReport"
          hide-actions
          class="elevation-1"
          style="width: 100%; margin: 15px 0 0;"
          :no-data-text="$t('noTableDataAvailable')"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left px-2">{{ props.item.workDate }}</td>
              <td class="text-xs-left px-2">{{ props.item.userId }}</td>
              <td class="text-xs-left px-2">{{ props.item.userName }}</td>
              <td class="text-xs-left px-2">{{ props.item.workHours }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-card>

    <v-dialog v-model="dialog" width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2" style="padding: 10px;">売上報告確認</v-card-title>

        <div style="height: 20px;"></div>

        <v-container>
          <div style="font-size: 20px;">{{ editSalesReport.storeName }}</div>

          <v-flex>
            <v-autocomplete
              v-model="workedUsers"
              :items="salesUsers"
              label="販売員"
              item-text="userName"
              item-value="userId"
              chips
              multiple
              deletable-chips
              return-object
              prepend-icon="group"
            ></v-autocomplete>
          </v-flex>

          <v-data-table
            :headers="salesReportConfirmHeader"
            :items="salesReportDetail"
            hide-actions
            class="elevation-1"
            style="width: 100%;    margin: 15px 0 0;"
            :no-data-text="$t('noTableDataAvailable')"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.header.text }}</span>
                </template>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-left" width="100px">{{ props.item.itemName }}</td>
                <td class="text-xs-right" width="50px">{{ props.item.quantity }}</td>
                <td class="text-xs-right" width="50px">{{ props.item.presentQuantity }}</td>
                <td
                  class="text-xs-right"
                  width="50px"
                >{{ props.item.unitPrice * props.item.presentQuantity }}</td>
                <td class="text-xs-right" width="50px">{{ props.item.referenceStock }}</td>
              </tr>
            </template>
          </v-data-table>

          <div style="height: 35px;"></div>

          <v-layout row reverse>
            <v-flex xs4 sm4>
              <v-text-field
                v-model="sumTotal"
                box
                label="売上金額合計​"
                prepend-inner-icon="mdi-currency-jpy"
                readonly
                style="font-weight:bold !important;"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-flex xs12 sm12>
            <v-textarea outline v-model="remarks" label="日報内容​" readonly></v-textarea>
          </v-flex>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#4C728A" dark @click="dialog = false">閉じる</v-btn>
            <v-btn color="info" dark @click="updateSalesReport()">売上報告を更新する</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <div style="height: 30px;"></div>

    <v-flex xs12>
      <v-btn block color="success" @click="downloadCsv()" :disabled="disableExportBtn">
        <v-icon dark left>mdi-file-download</v-icon>計算して出力する
      </v-btn>
    </v-flex>

    <div style="height: 10px;"></div>

    <v-flex xs12>
      <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
        <v-icon color="black" left>home</v-icon>Home
      </v-btn>
    </v-flex>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import { mapState } from 'vuex'
import moment from 'moment-timezone'
import axios from 'axios'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  methods: {
    onChangeMonth() {
      console.log('onChangeMonth')

      this.incentiveMonth = this.monthForPicker.replace(/-/g, '/')
    },
    forwardOrderConfirm() {
      this.$store.commit(
        'SET_ORDER_CONFIRM_SELECTED_SHIPPING_DATE',
        moment(new Date()).format('YYYY/MM/DD')
      )
      this.$router.push({
        name: 'admin/new-order-confirm',
      })
    },
    onFileChange(e) {
      // const files = e.target.files

      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }

      // if (files.length > 0) {
      //   this.dispEmptyText = false
      //   const file = files[0]
      //   const reader = new FileReader()
      //   reader.onload = e => {
      //     this.imageData = e.target.result
      //   }
      //   reader.readAsDataURL(file)
      // }
    },
    pickFile() {
      this.$refs.file.click()
    },
    upload() {
      console.log('upload')

      this.dialog = false

      let thisObj = this

      if (!this.incentiveMonth) {
        this.$parent.$parent.$parent.showErrorDialog(
          '対象年月を選択してください'
        )
        return
      }

      if (!this.targetFile) {
        this.$parent.$parent.$parent.showErrorDialog(
          '勤務データを選択してください'
        )
        return
      }

      let formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', 'UTF-8')
      formData.append('incentiveMonth', this.incentiveMonth.replace(/\//g, ''))

      this.loading = true
      ServerApiCallService.uploadIncentiveFile(formData)
        .then((response) => {
          this.targetFile = []
          this.$refs.file.value = null
          this.fileName = ''
          this.responseFilter(response)
          this.disableExportBtn = false
        })
        .catch((error) => {
          console.log('There was an error:', error)
          this.loading = false
        })
    },
    clear() {
      this.targetFile = []
      this.$refs.file.value = null
      this.fileName = ''
    },
    editSalesReport(item) {
      console.log('editSalesReport')
      // console.log(item)

      let thisObj = this

      this.selectedSalesReportId = item.salesReportId

      let request = {
        salesReportId: item.salesReportId,
      }

      ServerApiCallService.getSalesReportDetail(request)
        .then((response) => {
          this.salesReportDetail = response.data.salesReportDetails
          // console.log(this.salesReportDetail)

          this.sumTotal = 0

          this.salesReportDetail.forEach(function (row) {
            thisObj.sumTotal += row.unitPrice * row.quantity
          })

          this.sumTotal = Number(this.sumTotal).toLocaleString()

          this.salesUsers = []
          response.data.users.forEach(function (row) {
            var userList = {}
            if (!row.firstName) {
              userList = {
                userId: row.userId,
                userName: row.userId + ' ' + row.lastName,
              }
            } else {
              userList = {
                userId: row.userId,
                userName: row.userId + ' ' + row.lastName + ' ' + row.firstName,
              }
            }
            thisObj.salesUsers.push(userList)
          })

          this.workedUsers = []
          response.data.workedUsers.forEach(function (row) {
            thisObj.workedUsers.push(row.userId)
          })

          this.remarks = this.salesReportDetail[0].comments
        })
        .catch((error) => {
          console.log('There was an error:', error)
        })

      this.dialog = true
    },
    updateSalesReport() {
      console.log('updateSalesReport')

      var selectedSalesUsers = []
      for (let i = 0; i < this.workedUsers.length; i++) {
        if (this.workedUsers[i].userId) {
          selectedSalesUsers.push(this.workedUsers[i].userId)
        } else {
          selectedSalesUsers.push(this.workedUsers[i])
        }
      }

      let request = {
        salesReportId: this.selectedSalesReportId,
        workedUsers: selectedSalesUsers,
        incentiveMonth: this.incentiveMonth.replace(/\//g, ''),
      }

      ServerApiCallService.updateSalesReportForIncentive(request)
        .then((response) => {
          this.responseFilter(response)
        })
        .catch((error) => {
          console.log('There was an error:', error)
        })
    },
    responseFilter(response) {
      console.log('responseFilter')

      this.dialog = false

      // 重複データの削除
      var uniq = {}
      this.diffSalesReport = response.data.diffSalesReportUsers.filter(
        (obj) => !uniq[obj.salesReportId] && (uniq[obj.salesReportId] = true)
      )

      this.diffSalesReport.forEach((row) => {
        var tmpReportUserId = []
        var csvUserId = []
        response.data.diffSalesReportUsers.forEach((responseRow) => {
          if (row.salesReportId == responseRow.salesReportId) {
            tmpReportUserId.push(responseRow.reportUserId)

            if (responseRow.csvUserId) {
              csvUserId.push(responseRow.csvUserId)
            }
          }
        })

        row.reportUserId = tmpReportUserId
          .filter((item, idx, array) => {
            return array.indexOf(item) === idx
          })
          .toString()

        row.csvUserId = csvUserId
          .filter((item, idx, array) => {
            return array.indexOf(item) === idx
          })
          .toString()

        if (Array.isArray(row.reportUserId)) {
          row.reportUserId.sort()
        }
        if (Array.isArray(row.csvUserId)) {
          row.csvUserId.sort()
        }

        row.dispFlg = true
        if (
          JSON.stringify(row.reportUserId) === JSON.stringify(row.csvUserId)
        ) {
          row.dispFlg = false
        }

        row.salesReportDate = moment(row.salesReportDate, 'YYYYMMDD').format(
          'YYYY/MM/DD'
        )
      })

      this.noExistSalesReport = response.data.noExistSalesReport
      this.noExistSalesReport.forEach((row) => {
        row.workDate = moment(row.workDate, 'YYYYMMDD').format('YYYY/MM/DD')
        row.workHours = moment(row.workHours, 'HH:mm:ss').format('HH:mm')
      })

      this.dispTable = true
      this.loading = false
    },
    downloadCsv() {
      console.log('downloadCsv')

      if (!this.incentiveMonth) {
        this.$parent.$parent.$parent.showErrorDialog(
          '対象年月を選択してください'
        )
        return
      }

      let request = {
        incentiveMonth: this.incentiveMonth.replace(/\//g, ''),
      }

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken'),
          },
        })
        .post('/admin/incentive-download', request, {
          responseType: 'blob',
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download =
            'インセンティブ_' + this.incentiveMonth.replace(/\//g, '') + '.csv'
          link.click()
        })
    },
  },
  data() {
    return {
      selectedSalesReportId: '',
      disableExportBtn: true,
      noExistSalesReport: [],
      salesReportDetail: [],
      sumTotal: 0,
      remarks: '',
      loading: false,
      menu: '',
      incentiveMonth: '',
      monthForPicker: '',
      diffSalesReportHeaders: [
        {
          text: '売上報告日',
          align: 'left',
          sortable: true,
          fixed: false,
          class: 'px-2',
          value: 'salesReportDate',
        },
        {
          text: '店舗名',
          align: 'left',
          sortable: false,
          fixed: false,
          class: 'px-2',
        },
        {
          text: '売上報告上の販売員',
          align: 'left',
          sortable: false,
          fixed: false,
          class: 'px-2',
        },
        {
          text: '勤怠データ上の販売員',
          align: 'left',
          sortable: false,
          fixed: false,
          class: 'px-2',
        },
      ],
      diffSalesReport: [],
      diffCsvUsers: [],
      noExistSalesReportHeaders: [
        {
          text: '勤務日',
          align: 'left',
          sortable: true,
          fixed: false,
          class: 'px-2',
          value: 'workDate',
        },
        {
          text: '社員コード',
          align: 'left',
          sortable: false,
          fixed: false,
          class: 'px-2',
        },
        {
          text: '名前',
          align: 'left',
          sortable: false,
          fixed: false,
          class: 'px-2',
        },
        {
          text: '実労働時間',
          align: 'left',
          sortable: false,
          fixed: false,
          class: 'px-2',
        },
      ],
      fileName: '',
      dispTable: false,
      dialog: false,
      salesReportConfirmHeader: [
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false,
        },
        {
          text: '売上個数',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
        {
          text: 'プレゼント',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
        {
          text: '売上金額',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
        {
          text: '現在在庫',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
        },
      ],
      selectedReportDetail: [],
      workedUsers: [],
      salesUsers: [],
    }
  },
}
</script>

<style>
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>
